import { DeviceType } from "@tether-web-portal/types/DeviceType";

export const DeviceTypeLabel: Record<DeviceType, string> = {
  [DeviceType.EMS2DESK]: "EMS2 Desk",
  [DeviceType.ERS2EYE]: "ERS2 Eye",
  [DeviceType.SOLAR_CSV]: "Solar CSV",
  [DeviceType.MILESIGHT_CT]: "Milesight CT",
  [DeviceType.MILESIGHT_CT_PHASE]: "Milesight CT Phase",
  [DeviceType.MILESIGHT_CT_THREE_PHASE]: "Milesight CT Three Phase",
  [DeviceType.MILESIGHT_CTH01]: "Milesight CTH01 Power Monitor Hub",
  [DeviceType.MILESIGHT_CTH01_CIRCUIT]: "Milesight CTH01 Circuit",
  [DeviceType.MILESIGHT_CTH01_THREE_PHASE_CIRCUIT]: "Milesight CTH01 Three Phase Circuit",
  [DeviceType.MILESIGHT_CTH01_PHASE]: "Milesight CTH01 Phase",
  [DeviceType.KROHNE_AFE400_FLOWMETER]: "Krohne AFE400 Flowmeter",
  [DeviceType.MILESIGHT_EM300]: "Milesight EM300",
  [DeviceType.PFLOW_E3R_FLOWMETER]: "PFlow E3R Flowmeter",
  [DeviceType.MILESIGHT_AM103]: "Milesight AM103",
  [DeviceType.MILESIGHT_AM102]: "MouldWatch Sensor",
  [DeviceType.MILESIGHT_AM308]: "Milesight AM308",
  [DeviceType.MILESIGHT_AM319]: "Milesight AM319",
  [DeviceType.MILESIGHT_WS202]: "Milesight WS-202",
  [DeviceType.MILESIGHT_WS203]: "Milesight WS-203",
  [DeviceType.MILESIGHT_WS523]: "Milesight WS-523",
  [DeviceType.MILESIGHT_VS321]: "Milesight VS-321",
  [DeviceType.MILESIGHT_VS34X]: "Milesight VS-34X",
  [DeviceType.MILESIGHT_VS330]: "Milesight VS-330",
  [DeviceType.MILESIGHT_VS121]: "Milesight VS-121",
  [DeviceType.MILESIGHT_VS360]: "Milesight VS-360",
  [DeviceType.UNKNOWN]: "Unknown Device",
  [DeviceType.EASTRON_POWER]: "Eastron Power",
  [DeviceType.VICTRON_ENERGY_INVERTER]: "Victron Energy Inverter",
  [DeviceType.ELSYS_ERS]: "Elsys ERS",
  [DeviceType.ELSYS_ERS_LITE]: "Elsys ERS Lite",
  [DeviceType.ELSYS_ERS_CO2]: "Elsys ERS CO₂",
  [DeviceType.ELSYS_ERS_CO2_LITE]: "Elsys ERS CO₂ Lite",
  [DeviceType.ELSYS_ERS_VOC]: "Elsys ERS VOC",
  [DeviceType.ELSYS_ERS_EYE]: "Elsys ERS Eye",
  [DeviceType.ELSYS_ERS_SOUND]: "Elsys ERS Sound",

  [DeviceType.FLEXSENSE]: "FlexSense",
  [DeviceType.FLEXSENSE_PROBE]: "FlexSense",
  [DeviceType.VOLTDROP]: "VoltDrop",
  [DeviceType.VOLTDROP_PHASE]: "VoltDrop",
  [DeviceType.ROOM_RADAR]: "Room Radar",
  [DeviceType.ROOM_RADAR_LINE]: "Room Radar",
  [DeviceType.ROOM_RADAR_REGION]: "Room Radar",
  [DeviceType.MOKO_LW005]: "PowerQ",
  [DeviceType.GATEWAY]: "Gateway",
  [DeviceType.MILESIGHT_VS351]: "Door Radar",
  [DeviceType.MILESIGHT_EM320]: "Temp and Humidity Sensor",
  [DeviceType.QUANDIFY_CUBICMETER]: "Quandify CubicMeter",
  [DeviceType.BOVE_BECO]: "Bove Ultrasonic Water Meter",
  [DeviceType.GENUS_INTELLILOG]: "Genus IntelliLog Pulse Meter",
  [DeviceType.HOTDROP]: "HotDrop",
  [DeviceType.ENVIROQ]: "EnviroQ",
  [DeviceType.THERMALQ]: "ThermalQ",
  [DeviceType.AIRWITS]: "Airwits IAQ",
  [DeviceType.AIRWITS_IAQ]: "Airwits IAQ",
  [DeviceType.AIRWITS_CO2]: "Airwits CO2",
  [DeviceType.AIRWITS_CO2_PLUS]: "Airwits CO2 +",
  [DeviceType.AIRWITS_PM]: "Airwits PM",
  [DeviceType.DETECTIFY]: "Detectify",
  [DeviceType.PCS_FLOWMETER]: "Ultrasonic Flowmeter",
  [DeviceType.ADEUNIS_PULSE_WATER]: "Adeunis Pulse Water Meter",
  [DeviceType.ADEUNIS_PULSE_GAS]: "Adeunis Pulse Gas Meter",
  [DeviceType.ADEUNIS_PULSE]: "Adeunis Pulse Meter",
};
